module.exports = "/src/views/player/help/images/lesorub.jpg";